/** @format */

/* eslint-disable */
import React, { useState, useEffect } from 'react'
import localize from '../../../../../../Global/Localize'
import {
  formatCurrency,
  formatDate,
} from '../../../../../../Helpers/formatters'
import {
  creditReferenceBureauQueryStatus,
  identityCardType,
} from '../../../../../../Global/enumeration'
import { getData, postData } from '../../../../../../Helpers/webApi'
import BreadCrumb from '../../../../../../Components/BreadCrumb/Index'
import DatePicker from '../../../../../../Components/Date/DatePicker'
import SimpleTable from '../../../../../../Components/Tables/SimpleTable'
import Pager from '../../../../../../Components/Tables/Pager'
import ModalTemplate from '../../../../../../Components/ModalTemplate/ModalTemplate'
import { GlobalValidationErrors } from '../../../../../../Validation/ValidationState'
import EnumsServerCombo from '../../../../../../Components/ComboBox/EnumsServerCombo'
import Loader from '../../../../../../Components/Loaders/Loader'
import AddNewButton from '../../../../../../Components/Buttons/AddNewButton/AddNewButton'

const IdentityScrub = () => {
  const columns = [
    {
      label: localize('createdDate'),
      template: r => <>{formatDate(r.createdDate, false)}</>,
    },
    {
      label: localize('status'),
      template: r => <>{r.statusDescription}</>,
      sortBy: 'statusDescription',
    },
    {
      label: localize('reportType'),
      template: r => <>{r.reportTypeDescription}</>,
      sortBy: 'reportTypeDescription',
    },
    {
      label: localize('identityType'),
      template: r => <>{r.identityTypeDescription}</>,
      sortBy: 'identityTypeDescription',
    },
    {
      label: localize('identityNumber'),
      template: r => <>{r.identityNumber}</>,
      sortBy: 'identityNumber',
    },
    {
      label: localize('fullName'),
      template: r => <>{r.fullName}</>,
    },
    {
      label: localize('phoneNumber'),
      template: r => <>{r.phone}</>,
    },

    {
      label: localize('email'),
      template: r => <>{r.email}</>,
      sortBy: 'email',
    },
    {
      label: localize('gender'),
      template: r => <>{r.gender}</>,
      sortBy: 'gender',
    },
    {
      label: localize('employmentName'),
      template: r => <>{r.employmentName}</>,
      sortBy: 'employmentName',
    },
    {
      label: localize('employmentDate'),
      template: r => <>{formatDate(r.employmentDate)}</>,
      sortBy: 'employmentDate',
    },
    {
      label: localize('postalAddress'),
      template: r => <>{r.postalAddress}</>,
      sortBy: 'postalAddress',
    },
    {
      label: localize('physicalAddress'),
      template: r => <>{r.physicalAddress}</>,
      sortBy: 'physicalAddress',
    },
    {
      label: localize('dateOfBirth'),
      template: r => <>{formatDate(r.dateOfBirth)}</>,
      sortBy: 'dateOfBirth',
    },
    {
      label: localize('hasError'),
      template: r => (
        <span className="text-capitalize">
          {localize(r.hasError.toString())}
        </span>
      ),
      sortBy: 'hasError',
    },
    {
      label: localize('apiCode'),
      template: r => <>{r.apiCode}</>,
    },
    {
      label: localize('apiCodeDescription'),
      template: r => <>{r.apiCodeDescription}</>,
    },
    {
      label: localize('transactionId'),
      template: r => <>{r.transactionId}</>,
    },
    {
      label: localize('thirdPartyWalletResponse'),
      template: r => <>{r.thirdPartyWalletResponse}</>,
    },
    {
      label: localize('createdBy'),
      template: r => <>{r.createdBy}</>,
    },
    {
      label: localize('modifiedBy'),
      template: r => <>{r.createdBy}</>,
    },
    {
      label: localize('modifiedDate'),
      template: r => <>{formatDate(r.modifiedDate)}</>,
    },
  ]

  const [isBusy, setIsBusy] = useState(false)
  const [error, setError] = useState(false)
  const [tableData, setTableData] = useState([])
  const [search, setSearch] = useState('')
  const [mode, setMode] = useState(null)
  const [reqParams, setReqParams] = useState({
    status: 3,
    text: '',
    pageIndex: 0,
    pageSize: 10,
    startDate: null,
    dateRequestsFilter: 15,
    endDate: null,
    customDate: false,
  })
  const [tableMeta, setTableMeta] = useState({ ...reqParams, itemsCount: 0 })
  const [selectedIdentityScrubQuery, setSelectedIdentityScrubQuery] =
    useState(null)
  const [refreshAt, setRefreshAt] = useState(false)
  const [globalValidationErrors, setGlobalValidationErrors] =
    GlobalValidationErrors.use()

  async function handleSubmit() {
    setIsBusy(true)
    const { success } = await postData(
      '/CreditReferenceBureau/add-new-identity-scrub-query',
      selectedIdentityScrubQuery || {
        identityNumber: '',
      },
      false,
      'Operation Completed Successfully'
    )

    if (success) {
      setIsBusy(false)
      setMode(null)
      setSelectedIdentityScrubQuery(null)
      setRefreshAt(!refreshAt)
    } else {
      setIsBusy(false)
    }
  }

  function closeModal() {
    setMode(null)
    setSelectedIdentityScrubQuery(null)
    setGlobalValidationErrors({})
  }

  function clearValidation(column) {
    setGlobalValidationErrors(validation => {
      delete validation[column]
      return validation
    })
  }

  useEffect(() => {
    loadTableData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reqParams.pageIndex, reqParams.pageSize, refreshAt])

  async function loadTableData() {
    setIsBusy(true)
    setError(false)
    const { success, data } = await getData(
      '/CreditReferenceBureau/find-identity-scrub-queries-by-status-date-and-filter-in-page',
      reqParams,
      false
    )
    if (success) {
      setIsBusy(false)
      setTableData(data.pageCollection || [])
      setTableMeta({ ...reqParams, itemsCount: data.itemsCount })
    } else {
      setIsBusy(false)
      setError(true)
    }
  }

  const handleAdd = async () => {
    setMode('add')
    setSelectedIdentityScrubQuery({
      identityType: Object.keys(identityCardType)[1],
    })
  }

  return (
    <>
      <BreadCrumb
        tree={[
          localize('backOfficeManagement'),
          localize('identityScrubQueries'),
        ]}
      />
      <div className="row">
        <div className="col-12">
          <div className="card bg-white">
            <div className="card-body">
              {isBusy ? (
                <Loader />
              ) : (
                <>
                  {error ? (
                    <div className="col-12 d-flex align-items-center justify-content-center text-danger">
                      <i className="uil uil-exclamation-circle m-2 fs-4"></i>
                      <div className="fs-5 text-danger">
                        {localize('failedToLoadData')}
                      </div>
                    </div>
                  ) : (
                    <>
                      <div className="row mb-2">
                        <div className="col-md-4">
                          <div className="mb-3">
                            <AddNewButton handleClickAddButton={handleAdd} />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="d-flex align-items-center col-2">
                          <label
                            htmlFor="recordsPerPage"
                            className=""
                            style={{
                              marginLeft: -10,
                              textTransform: 'capitalize',
                            }}
                          >
                            {localize('recordsPerPage')}
                          </label>
                          <select
                            className="form-select ms-3"
                            style={{ maxWidth: 'fit-content' }}
                            defaultValue={reqParams.pageSize}
                            onChange={e => {
                              setReqParams({
                                ...reqParams,
                                pageIndex: 0,
                                pageSize: e.target.value,
                              })
                            }}
                          >
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                          </select>
                        </div>
                        <div className="d-flex align-items-center col-2">
                          <EnumsServerCombo
                            enumsKey="CreditReferenceBureauQueryStatus"
                            value={reqParams?.status}
                            onChange={e =>
                              setReqParams({
                                ...reqParams,
                                status: e.value,
                              })
                            }
                          />
                        </div>
                        <div className="col-md-4">
                          <div className="d-flex align-items-center">
                            <label
                              className="text-capitalize col-md-3"
                              htmlFor="searchByDate"
                            >
                              {localize('dateRange')}
                            </label>
                            <DatePicker
                              onSelect={v => {
                                if (v.custom) {
                                  setReqParams({
                                    ...reqParams,
                                    customDate: true,
                                    startDate: v.startDate,
                                    endDate: v.endDate,
                                  })
                                } else {
                                  setReqParams({
                                    ...reqParams,
                                    customDate: false,
                                    dateRequestsFilter: v.value,
                                  })
                                }
                              }}
                            />
                          </div>
                        </div>
                        <form
                          className="d-flex align-items-center col-4 col"
                          onSubmit={e => {
                            e.preventDefault()
                            setReqParams({
                              ...reqParams,
                              text: search,
                            })
                          }}
                        >
                          <label
                            className="ms-2 text-capitalize"
                            htmlFor="searchTable"
                          >
                            {localize('search')}
                          </label>
                          <input
                            type="search"
                            id="searchTable"
                            className="form-control ms-2"
                            defaultValue={reqParams.text}
                            onChange={e => {
                              setSearch(e.target.value)
                              setReqParams({
                                ...reqParams,
                                text: e.target.value,
                              })
                            }}
                          />
                          <button
                            id="IdentityScrubQueryFilterButton"
                            type="button"
                            className="btn btn-primary me-2"
                            onClick={() => {
                              loadTableData()
                            }}
                          >
                            <i className="uil uil-filter"></i>
                          </button>
                        </form>
                      </div>
                      <div className="row col-12 mt-2">
                        <SimpleTable data={tableData} columns={columns} />
                      </div>
                      <div className="row col-12 mt-2">
                        <Pager
                          {...tableMeta}
                          onPageChange={p =>
                            setReqParams({ ...reqParams, pageIndex: p })
                          }
                        />
                      </div>
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      {mode && (
        <>
          <ModalTemplate
            modalMode={mode}
            modalTitle="identityScrubQueries"
            handleClose={closeModal}
            handleAction={handleSubmit}
            modalClassName="modal-lg"
            actionText={mode === 'add' ? 'create' : ''}
          >
            {isBusy ? (
              <Loader />
            ) : (
              <>
                <div className="row mb-2">
                  <div className="col d-flex align-items-center mb-2">
                    <label className="col-3 text-capitalize">
                      {localize('identityType')}
                    </label>
                    <EnumsServerCombo
                      enumsKey="IdentityCardType"
                      value={
                        selectedIdentityScrubQuery?.identityTypeDescription
                      }
                      onChange={e =>
                        setSelectedIdentityScrubQuery({
                          ...selectedIdentityScrubQuery,
                          identityType: e.value,
                        })
                      }
                    />
                  </div>
                  <div
                    className="col d-flex align-items-center with-validation"
                    validation-message={
                      globalValidationErrors['IdentityNumber']?.message
                    }
                  >
                    <label className="col-3 text-capitalize">
                      {localize('identityNumber')}
                    </label>
                    <input
                      type="text"
                      className="form-control ms-2"
                      value={selectedIdentityScrubQuery?.identityNumber || ''}
                      onChange={e => {
                        clearValidation('IdentityNumber')
                        setSelectedIdentityScrubQuery({
                          ...selectedIdentityScrubQuery,
                          identityNumber: e.target.value,
                        })
                      }}
                    />
                  </div>
                </div>
              </>
            )}
          </ModalTemplate>
        </>
      )}
    </>
  )
}

export default IdentityScrub
